import type { ProgressProps as AntdProgressProps } from "antd";
import { Progress as AntdProgress } from "antd";
import React from "react";

const Progress = (props: AntdProgressProps) => {
  return <AntdProgress {...props} />;
};

export default Progress;
